import { Icon } from '../UI';

import { SvgProps } from '../UI/Icon/Icon';
import { Mode } from './types';

const MODES: Mode[] = ['viewGraph', 'viewGrid', 'viewList'];

export const SelectViewMode = ({
  mode,
  onSelect,
}: {
  mode: Mode;
  onSelect(mode: Mode): void;
}) => (
  <div
    className={`
      flex
      w-1/4
      px-5
      h-full
      justify-evenly
      items-center
      font-semibold
    `}
  >
    {MODES.map((svgName) => (
      <Icon
        key={svgName}
        activeColor="black"
        className="cursor-pointer"
        color="grey-50"
        hoverColor="grey-70"
        isActive={svgName === mode}
        svgName={svgName as SvgProps['svgName']}
        onClick={() => onSelect(svgName)}
      />
    ))}
  </div>
);
